import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import SelectInput from 'components/ui/forms/field/select-input/SelectInput'

import { MonitoringStatus } from 'enum/monitoring-status.enum'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from './constants'

interface Option {
  value: MonitoringStatus
  label: string
}

interface StateProps {
  value?: MonitoringStatus
  onChange: (value?: Option | null) => void
}

export const State = ({ value, onChange }: StateProps) => {
  const { t } = useTranslation()
  const tRelative = useTranslationRankmi({
    prefix,
  })
  const options = useMemo<Option[]>(
    () => [
      {
        value: MonitoringStatus.Pending,
        label: t(`administration.monitor.states.pending`),
      },
      {
        value: MonitoringStatus.Finish,
        label: t(`administration.monitor.states.finish`),
      },
      {
        value: MonitoringStatus.InProgress,
        label: t(`administration.monitor.states.inprogress`),
      },
    ],
    [t]
  )

  const selected = useMemo(
    () => options.find((option) => option.value === value),
    [options, value]
  )

  return (
    <SelectInput
      name="state"
      label={tRelative('state')}
      options={options}
      closeMenuOnSelect={true}
      value={selected}
      isMulti={false}
      onChange={onChange}
    />
  )
}

export default State
